/**
 * Users Page Logic
 *
 * Admin user management page
 */

import { initAuthenticatedPage, hasPermission } from '../app/init.js';
import { fillUsersTable, createUser } from '../admin/users.js';
import { declareLoading, notificationDialog } from '../ui/dialogs.js';

/**
 * Initialize the users page
 */
export async function initUsersPage(): Promise<void> {
  const user = await initAuthenticatedPage();
  if (!user) return; // Will redirect to login

  // Check user management permission
  if (!hasPermission('manage-users')) {
    notificationDialog('Access denied: User management permission required');
    window.location.href = '/';
    return;
  }

  // Load user table
  declareLoading();
  try {
    await fillUsersTable();
    // Show content after table is ready
    const content = document.getElementById('content');
    if (content) content.style.display = 'block';
  } catch (error) {
    const msg = error instanceof Error ? error.message : 'Failed to load users';
    notificationDialog(msg);
  }
}

// Export to window for onclick handlers
if (typeof window !== 'undefined') {
  (window as unknown as Record<string, unknown>).createUser = createUser;
  (window as unknown as Record<string, unknown>).initUsersPage = initUsersPage;
}
